/**
 * The browser half of ADR-0024's rule that an e-mail is never captured
 * anywhere. `packages/observability` holds the same two functions for the
 * backends and cannot be imported here — it pulls in `posthog-node`, which
 * would land in this bundle. The duplication is deliberate and the two must
 * stay identical; the alternative is a scrub point that covers one of the two
 * surfaces feeding the same PostHog project.
 *
 * The handlers here are wide: `unhandledrejection` catches every rejected
 * promise in the app, including the failed sign-in calls that are the only
 * place an address is held.
 */

const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

const SCRUBBED_KEYS = new Set(['email', 'e-mail', 'authorization', 'cookie', 'set-cookie']);

export function scrubError(error: unknown): unknown {
  if (!(error instanceof Error)) return error;
  const scrubbed = new Error(error.message.replace(EMAIL_PATTERN, '[scrubbed]'));
  scrubbed.name = error.name;
  scrubbed.stack = error.stack?.replace(EMAIL_PATTERN, '[scrubbed]');
  if (error.cause !== undefined) {
    scrubbed.cause = scrubError(error.cause);
  }
  return scrubbed;
}

export function scrubProperties(
  properties: Record<string, unknown>
): Record<string, unknown> {
  const scrubbed: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(properties)) {
    scrubbed[key] = SCRUBBED_KEYS.has(key.toLowerCase()) ? '[scrubbed]' : value;
  }
  return scrubbed;
}
